var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditcamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33334 17.7755H15.0667C17.3667 17.7755 18.7167 16.5152 18.825 14.8523V7.67724C18.9417 5.93365 17.5083 5.26366 15.7 5.26366C15.1917 5.26366 14.725 4.98113 14.4917 4.54524L13.8917 3.37477C13.5083 2.6402 12.5083 2.03479 11.6583 2.03479H9.75001C8.89168 2.03479 7.89168 2.6402 7.50834 3.37477L6.90834 4.54524C6.67501 4.98113 6.20834 5.26366 5.70001 5.26366C3.89168 5.26366 2.45834 5.93365 2.57501 7.67724L2.57489 14.8523C2.67489 16.5152 4.03334 17.7755 6.33334 17.7755Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44922 6.47461H11.9492",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6986 14.5467C12.1902 14.5467 13.4069 13.3682 13.4069 11.9233C13.4069 10.4783 12.1902 9.2998 10.6986 9.2998C9.2069 9.2998 7.99023 10.4783 7.99023 11.9233C7.99023 13.3682 9.2069 14.5467 10.6986 14.5467Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditcamera);
export default __webpack_public_path__ + "static/media/editcamera.133f96c1ea58696fa1406670a3104305.svg";
export { ForwardRef as ReactComponent };